import axiosInstance from "./axiosInstance";
import { err } from "../utils/toastHelper";

const handleError = (error: any) => {
  if (!navigator.onLine) {
    err("No internet connection. Please check your network.");
    return { error: "No internet connection" };
  }

  const response = error.response;

  if (response) {
    const status = response.status;
    // const message = response.data?.message || "Something went wrong.";

    if (status === 401) {
      localStorage.clear();
      // window.location.href = "./signup";
    }

    if (status === 403 || status === 404) {
      // warning(message);
      return response.data;
    }

    // err(message);
    return response.data;
  }

  console.error("Something went wrong. Please try again.", error);
  return error;
};

export default class BaseApi {
  static setAccessToken(token: string) {
    localStorage.setItem("authToken", token);
    window.dispatchEvent(new Event("authChanged"));
  }

  static getHeaders(extraHeaders = {}) {
    const token = localStorage.getItem("authToken");
    return {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      ...extraHeaders,
    };
  }

  static camelToSnake(str: string) {
    return str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);
  }

  // Generic request handler
  private static async request(
    method: string,
    endpoint: string,
    payload?: any,
    extraHeaders = {},
    config = {},
  ) {
    if (!navigator.onLine) {
      err("No internet connection. Please check your network.");
      return { error: "No internet connection" };
    }

    try {
      const options: any = {
        url: endpoint,
        method,
        headers: this.getHeaders(extraHeaders),
        ...config,
      };

      if (["post", "put", "patch"].includes(method.toLowerCase())) {
        options.data = payload;
      }

      const res = await axiosInstance(options);
      return res.data;
    } catch (error) {
      return handleError(error);
    }
  }

  // HTTP methods using the generic request
  static get(endpoint: string, extraHeaders = {}, config = {}) {
    return this.request("get", endpoint, undefined, extraHeaders, config);
  }

  static post(endpoint: string, payload: any, extraHeaders = {}, config = {}) {
    return this.request("post", endpoint, payload, extraHeaders, config);
  }

  static put(endpoint: string, payload: any, extraHeaders = {}, config = {}) {
    return this.request("put", endpoint, payload, extraHeaders, config);
  }

  static patch(
    endpoint: string,
    payload?: any,
    extraHeaders = {},
    config = {},
  ) {
    return this.request("patch", endpoint, payload, extraHeaders, config);
  }

  static delete(endpoint: string, extraHeaders = {}, config = {}) {
    return this.request("delete", endpoint, undefined, extraHeaders, config);
  }
}
